import type { LocationAddButtonProps } from "./location-add-button.type";

import { useTranslation } from "react-i18next";

import LocationCreate from "@/modules/location/location-create";
import ModelAddButton from "@/modules/model-add-button";

const LocationAddButton = ({
  parentLocation,
  ...options
}: LocationAddButtonProps) => {
  const { t } = useTranslation();

  const isCreatingSector = !!parentLocation;
  const title = isCreatingSector
    ? t("sector:add.label")
    : t("location:add.label");

  return (
    <ModelAddButton
      model="location"
      sidePanelTitle={title}
      buttonTitle={title}
      component={<LocationCreate parentLocation={parentLocation} />}
      {...options}
    />
  );
};

export default LocationAddButton;
